import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData } from "../../../../Utilitie";
import * as echarts from "echarts";

const CrackMonthlyReportGraph = ({
  data,
  sections,
  selectedMonths,
  months,
  selectedFy,
}) => {
  useEffect(() => {
    if (selectedMonths.length === 0) return;

    const chartDom = document.getElementById("CrackChart1");
    let myChart = echarts.init(chartDom);

    const prevYearTotal = {};
    const currYearTotal = {};

    months.forEach((month) => {
      prevYearTotal[month] = 0;
      currYearTotal[month] = 0;
    });

    sections.forEach((section) => {
      const prevData = section.children[0]?.data || [];
      const currData = section.children[1]?.data || [];

      prevData.forEach(({ month_name, total_no_of_crack }) => {
        prevYearTotal[month_name] += Number(total_no_of_crack) || 0;
      });

      currData.forEach(({ month_name, total_no_of_crack }) => {
        currYearTotal[month_name] += Number(total_no_of_crack) || 0;
      });
    });

    const prevDataArray = selectedMonths.map((m) => prevYearTotal[m] || 0);
    const currDataArray = selectedMonths.map((m) => currYearTotal[m] || 0);

    const option = {
      title: {
        text: `Month Wise Comparison`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      legend: {
        top: 30,
        data: [
          `Prev (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `Curr (${selectedFy})`,
        ],
      },
      series: [
        {
          name: `Prev (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevDataArray, // ✅ FIXED
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `Curr (${selectedFy})`,
          type: "bar",
          data: currDataArray, // ✅ FIXED
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
      ],
    };

    myChart.setOption(option);
    const handleResize = () => {
      if (myChart) myChart.resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (myChart) myChart.dispose();
    };
  }, [selectedMonths, selectedFy, data]);

  return (
    <div>
      <div className="newUiBody">
        <div
          id="CrackChart1"
          style={{
            width: "100%",
            height: "50vh",
            minHeight: "350px",
            marginTop: "30px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default CrackMonthlyReportGraph;
